import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const UiContext = createContext(null);

const STORAGE_KEYS = {
  theme: 'ui.theme', // 'light' | 'dark' | 'system'
  contrast: 'ui.contrast', // 'normal' | 'high'
  lang: 'ui.lang' // 'en' | 'fr' | 'fa' | 'ar' | 'he'
};

export function UiProvider(props) {
  const [theme, setTheme] = useState(() => localStorage.getItem(STORAGE_KEYS.theme) || 'system');
  const [contrast, setContrast] = useState(() => localStorage.getItem(STORAGE_KEYS.contrast) || 'normal');
  const [lang, setLang] = useState(() => localStorage.getItem(STORAGE_KEYS.lang) || 'en');

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'system') {
      root.removeAttribute('data-theme');
    } else {
      root.setAttribute('data-theme', theme);
    }
    localStorage.setItem(STORAGE_KEYS.theme, theme);
  }, [theme]);

  useEffect(() => {
    const root = document.documentElement;
    if (contrast === 'high') {
      root.setAttribute('data-contrast', 'high');
    } else {
      root.removeAttribute('data-contrast');
    }
    localStorage.setItem(STORAGE_KEYS.contrast, contrast);
  }, [contrast]);

  useEffect(() => {
    document.documentElement.lang = lang;
    const rtl = ['ar', 'fa', 'he'];
    document.documentElement.dir = rtl.includes(lang) ? 'rtl' : 'ltr';
    localStorage.setItem(STORAGE_KEYS.lang, lang);
  }, [lang]);

  const value = useMemo(() => ({ theme, setTheme, contrast, setContrast, lang, setLang }), [theme, contrast, lang]);
  return <UiContext.Provider value={value} {...props} />;
}

export function useUi() {
  const ctx = useContext(UiContext);
  if (!ctx) throw new Error('useUi must be used within UiProvider');
  return ctx;
}


